export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_SOCKET_URL = process.env.REACT_APP_BASE_SOCKET_URL;
